import { useMemo } from 'react';
import type {
  ActionConstructor,
  ActionServerContext,
} from '../types';

export const useAction = <
  TAction,
  TContext extends ActionServerContext,
>(
  Action: ActionConstructor<TAction, TContext>,
  serverContext: TContext
) => {
  const action = useMemo(() => {
    if (serverContext.CurrentAccount) {
      return new Action(serverContext);
    }
    return null;
  }, [Action, serverContext]);

  return action;
};
